import React from "react";
import { Link } from "react-router-dom";
const InstallationGuide = () => {
  return (
        <div>
            {/* Spinner Start */}
           
            {/* Spinner End */}
        
   
            <div class="container installation_guide">
            <header>
        <h1>Rigid Core Installation <span class="highlight">Instructions</span></h1>
        <p>Our vinyl floorings are constructed with the patented Uniclic® tongue and groove design that locks the planks together to form a tight and durable joint that limits moisture from passing through the seams, can be installed over most floor surfaces, and suitable for both residential and light commercial interior applications. To assure satisfactory installation, please read all instructions before installing. </p>
    </header>

    <section class="requirements">
        <h2>Requirements & <span class="highlight">Site Conditions</span></h2>
        <ul>
            <li>✔ Make sure the sub-floor is flat, clean, and dry. Any uneven areas greater than 3/16 inch in 10 feet must be leveled.</li>
            <li>✔ The installation area is limited to a maximum of 10m x 10m. Use T-molding for larger areas.</li>
            <li>✔ Indoor use only in a climate-controlled environment, not exposed to direct sunlight.</li>
            <li>✔ Keep records of levelness and moisture testing.</li>
        </ul>
        <div class="">
            <p>✔ DO NOT use separate Pad for pre-attached vinyl planks.</p>
            <p>✔ DO NOT install planks over floors that are sloped for drainage. Residential and light commercial applications.</p>
            <p>✔ NOT for use on ramps.</p>
            <p>✔ Installation direction: It is recommended to install the length of the boards parallel to the main light direction.</p>
        </div>
    </section>

    <section class="installation">
        <h2>Prior To <span class="highlight">Installation</span></h2>
        <ul>
    <li>✔ Acclimate vinyl planks at least 48 hours to room temperature (60°-85°F) and relative humidity between 30%-55%.</li>
    <li>✔ Use a humidifier to maintain relative humidity if needed. Avoid installation under very dry/humid conditions.</li>
    <li>✔ DO NOT stack higher than ten cartons or place anything on top of uninstalled vinyl planks. Allow for air circulation.</li>
    <li>✔ Always check flooring materials for defects. Contact your supplier immediately if any defect is found.</li>
    <li>✔ Open multiple cartons and mix planks together to ensure a natural pattern before installation.</li>
    <li>✔ Install all cabinets prior to installing flooring materials (DO NOT install cabinets on top of the flooring).</li>
    <li>✔ Remove all furniture from the room, along with any existing quarter round, baseboard molding, or cove base.</li>
    <li>✔ Inspect the subfloor to ensure it is dry, clean, solid, and flat. Remove any adhesive residue before installation.</li>
    <li>✔ Undercut doorway moldings to match the thickness of the flooring. Ensure doors still open and close properly after installation (minimum +1cm / 3/8").</li>
</ul>
<p>DO NOT install vinyl planks over soft subfloors (carpet) or areas prone to flooding.</p>
<p>PRO TIP : Purchase an additional 5% of flooring to allow for cuts and an additional 10% to 15% if installing diagonally. Excess flooring should be stored flat in a climate-controlled area for repairs in the event of future damage. </p>
    </section>

    <section class="tools">
        <h2>Tools</h2>
        <p>Carpenter square, utility knife, tape measure, pencil, long straight edge, chalk line, safety glasses, tapping block, pull bar</p>
    </section>

    <section class="subfloor">
        <h2>Subfloor</h2>
        <h3>Concrete Subfloors:</h3>
        <p>Make sure moisture vapor emissions does not exceed 5 lbs./24 hour per 1,000 sq. when tested with the Anhydrous Calcium Chloride Test in accordance with ASTM F 1869 or 85% RH in accordance with ASTM F 2170 "Standard Test Method for Determining Relative Humidity in Concrete Slabs using in situ Probes. Level uneven areas greater than 3/16" in a 10 feet. Holes and cracks in the cement must be patched, and expansion joints must be filled with a latex patching compound. Newly poured concrete floors must cure for a minimum of 90 days. Apply a 6 mils polyethylene moisture barrier before installation If the level of hydrostatic pressure is over 90% RH, or will be above 90% RH during the life of the slab. Please note it is the person installing the floor and/or the homeowner's responsibility to ensure a smooth substrate and that any moisture or alkalinity issues are resolved prior to installing the floor. Once installed, it becomes the installer's responsibility. </p>
        <h3>Wood Subfloors:</h3>
        <p>Must be solid and flat. Sand down high spots and fill low spots with leveling compound. Firmly fasten all loose boards and fill all gaps before installation.</p>
        <p>DO NOT install vinyl planks over wood floors/ laminate laid directly on concrete or bitumen.</p>
        <h3>Mosaics / Terrazzo / Ceramics:</h3>
        <p>Must be solid and flat. Level grout lines with the width or depth of 3/16" (5mm).</p>
        <h3>Textile floor covering (carpet) :</h3>
        <p>Must be removed.</p>
        <h3>Radiant Heat Subfloors :</h3>
        <p> Rigid Core Planks can be installed over in-floor radiant heating systems provided the subfloor surface does not exceed 85°F (29.44°C) at any point. The initial floor temperature should not exceed 70°F (21.11°C) for 48 hours prior, during, and after installation. Thereafter the temperature should be gradually increased to the desired setting up to 85°F (29.44°C). Because heat does aect plastic more than wood, you may need additional room for expansion (larger expansion gap) and contraction (wider base to allow for contraction) Radiant heating systems that are installed directly on top of the subfloor surface are not recommended. </p>
        <h3>Installing the Floor :</h3>
        <p>Begin installation parallel to the long dimension of the room, preferably parallel with the light sources (windows & doors). Snap a chalk line at the starting point to maintain alignment. Use planks mixed in from four or five cartons to achieve the ideal random pattern. </p>
    </section>

    <section class="flooring">
        <h2>Installing the Floor</h2>
        <p>When fitting around door trim it will be necessary to slide the plank under the trim. This can be accomplished easily by starting the row on the side of the room with the door trim and then sliding the plank into place once it is attached. The row can be completed by inserting the tongue onto the groove or the groove under the tongue depending on the direction. A tapping block and pull bar can also be used to lock the joints together while the planks are in a flat position. Use a series of light taps until the joint is gradually locked together. </p>
       
    </section>

    <section class="flooring">
        <h2>Under Doorframes :</h2>
        <p>When sawing the panels, ensure the expansion joint under the door at least 10mm (3/8"). If you cannot lift the panel, use an adapted tapping block or pull bar and hammer to tap the panels together with the planks flat on the floor. </p>
       
    </section>

    <section class="aftercare">
        <h2>After Care</h2>
        <ul>
    <li>✔ Maintain room temperature between 60° - 85°F; relative humidity between 40% and 70%.</li>
    <li>✔ Avoid bringing dirt, water, and sand indoors by using a suitable floor mat at all outside doors. Sweep and/or dust mop the floor daily to remove surface dirt. Clean walk-off mats regularly.</li>
    <li>✔ Do NOT use strong alkaline detergents or cleaning agents containing solvents. Always rinse with clean water. Use a white pad on an auto scrubber or a 175 RPM machine.</li>
    <li>✔ We recommend a diluted solution of Simple Green or another gentle cleaner for regular cleaning and removing grease and smudges.</li>
    <li>✔ Do NOT use harsh abrasive cleaners, bleach, ammonia, vinegar-based cleaners, wax, acrylic polishes, or oil soaps. These may dull or damage the finish, leaving a greasy film and making the floor slippery and harder to clean.</li>
    <li>✔ Protect your floor from direct sunlight or intense artificial lighting. Prolonged exposure to intense light may cause discoloration.</li>
    <li>✔ Do NOT roll or drag heavy objects across the floor. Avoid wearing shoes with heel taps, spikes, cleats, rocks, gravel, or sharp protruding objects.</li>
    <li>✔ Protect furniture and chair legs with proper felt or rubber caps.</li>
    <li>✔ Use office chairs and seats with soft rubber wheels suitable for vinyl flooring and/or use a suitable desk mat.</li>
</ul>

    </section>
    </div>
      
        <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
            <i className="bi bi-arrow-up"></i>
          </a>
      
      
            {/* Optional: Add any other content or components here */}
        
            <style>
              {`
                /* Add your custom CSS here */
                .service-item-top {
                  transition: transform 0.3s ease-in-out;
                }
        .installation_guide{margin-top:135px;}
                .service-item-top:hover {
                  transform: scale(1.05);
                }
            h1, h2 {

    color: #333;
}

h1 .highlight, h2 .highlight {
    color: #17224D;
}

ul {
    list-style: none;
    padding: 0;
}

ul li {
    background: url('check-icon.png') no-repeat left center;
    background-size: 16px;
    // padding-left: 25px;
    margin: 10px 0;
}

.warnings {
    background: #fff3cd;
    padding: 15px;
    border-left: 5px solid #ffa502;
    margin: 20px 0;
}

.warnings p {
    margin: 5px 0;
    color: #d35400;
}

section {
   
    // padding: 20px;
    border-radius: 10px;
   
    margin: 20px auto;
  
}

img {
    // width: 100%;
    border-radius: 8px;
   
}

/* Responsive Design */
@media (max-width: 768px) {
    body {
        padding: 10px;
    }

    section {
        padding: 15px;
    }
}
                /* Add any additional styling you want */
              `}
            </style>
          </div>
  );
};

export default InstallationGuide;
